export default {
  getAutocompletePaymentTerms: (state) => state.autocompletePaymentTerms,
  getPaymentTerms: (state) => state.paymentTerms,
  getPaymentTerm: (state) => (id) => {
    return state.paymentTerms.find(paymentTerm => paymentTerm.id === id)
  },
}